(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["salex-breadcrumbs"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const back = event.target.closest('[data-salex-back]');
    if (!back || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!document.referrer || window.history.length < 2) return;
    const referrer = new URL(document.referrer);
    if (referrer.origin !== window.location.origin || referrer.href === window.location.href) return;
    event.preventDefault();
    window.history.back();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["salex-multi-results"] && !Shopify.designMode) return;
  try {
    function matchesSalexGroups(product, groups) {
    const tags = new Set(product.tags);
    return [...groups].every(([group, values]) => group === 'features' ? values.every(value => tags.has(value)) : values.some(value => tags.has(value)));
  }

  if (!customElements.get('salex-multi-results')) {
    customElements.define('salex-multi-results', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.onReady = () => this.load();
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.onReady, {once:true, signal:this.controller.signal});
        else this.load();
        window.addEventListener('popstate', () => this.load(), {signal:this.controller.signal});
      }

      disconnectedCallback() { this.controller?.abort(); }

      async load() {
        const params = new URLSearchParams(window.location.search);
        const selected = params.getAll('sx');
        if (!selected.length) { document.documentElement.classList.remove('salex-results-fetching'); return; }
        const target = document.getElementById('ResultsList');
        if (!target) return;
        target.setAttribute('aria-busy', 'true');
        document.documentElement.classList.add('salex-results-fetching');
        const message = document.createElement('div');
        message.className = 'salex-results-message';
        message.setAttribute('role', 'status');
        message.textContent = this.dataset.loading;
        target.querySelector('.salex-results-message')?.remove();
        target.prepend(message);
        try {
          const source = new URL(window.location.pathname, window.location.origin);
          for (const [key, value] of params) {
            if (key.startsWith('filter.') || key === 'sort_by' || key === 'preview_theme_id') source.searchParams.append(key, value);
          }
          source.searchParams.set('view', 'salex-filter-data');
          const cacheKey = source.toString();
          if (this.cacheKey !== cacheKey) {
            const fetchPage = async page => {
              const url = new URL(source);
              url.searchParams.set('page', String(page));
              const response = await fetch(url, {signal:this.controller.signal});
              if (!response.ok) throw new Error('Collection request failed');
              const data = await response.json();
              if (!Array.isArray(data.products) || !Number.isInteger(data.pages)) throw new Error('Invalid collection data');
              return data;
            };
            const first = await fetchPage(1);
            const products = [...first.products];
            for (let page = 2; page <= first.pages; page += 2) {
              const pages = [fetchPage(page)];
              if (page + 1 <= first.pages) pages.push(fetchPage(page + 1));
              for (const part of await Promise.all(pages)) products.push(...part.products);
            }
            if (products.length !== first.count) throw new Error('Incomplete collection data');
            this.products = products;
            this.cacheKey = cacheKey;
          }
          const groups = new Map();
          for (const value of selected) {
            const group = value.match(/^sx-([a-z_]+)-/)?.[1];
            if (!group) throw new Error('Unknown filter');
            if (!groups.has(group)) groups.set(group, []);
            groups.get(group).push(value);
          }
          const products = this.products.filter(product => product.available && matchesSalexGroups(product, groups));
          this.render(products, target, Number(params.get('sx_page')) || 1);
          document.querySelectorAll('.products-count-wrapper [role=status]').forEach(status => { status.textContent = `${products.length} ${this.dataset.count}`; });
          document.documentElement.classList.remove('salex-results-fetching');
          target.setAttribute('aria-busy', 'false');
        } catch (error) {
          if (error.name === 'AbortError') return;
          target.replaceChildren(message);
          message.textContent = this.dataset.error;
          const retry = document.createElement('button');
          retry.type = 'button';
          retry.textContent = this.dataset.retry;
          retry.addEventListener('click', () => this.load());
          message.append(document.createElement('br'), retry);
          document.documentElement.classList.remove('salex-results-fetching');
          target.setAttribute('aria-busy', 'false');
        }
      }

      render(products, target, requestedPage) {
        const pageSize = Number(this.dataset.pageSize) || 24;
        const pages = Math.max(1, Math.ceil(products.length / pageSize));
        const page = Math.min(Math.max(1, requestedPage), pages);
        const previousGrid = target.querySelector('.product-grid');
        const grid = document.createElement('ul');
        grid.className = previousGrid?.className || 'product-grid';
        grid.setAttribute('role', 'list');
        grid.setAttribute('ref', 'grid');
        grid.setAttribute('data-testid', 'product-grid');
        grid.setAttribute('product-grid-view', previousGrid?.getAttribute('product-grid-view') || 'default');
        grid.style.setProperty('--product-grid-columns-desktop', 'repeat(auto-fill,minmax(235px,1fr))');
        grid.style.setProperty('--product-grid-gap-desktop', '28px 22px');
        grid.style.setProperty('--product-grid-gap-mobile', '20px 12px');
        const fragment = document.createDocumentFragment();
        for (const product of products.slice((page - 1) * pageSize, page * pageSize)) {
          const li = document.createElement('li');
          li.className = 'product-grid__item';
          li.dataset.productId = String(product.id);
          const link = document.createElement('a');
          link.className = 'salex-result-card';
          link.href = product.url;
          const media = document.createElement('div');
          media.className = 'salex-result-card__image';
          if (product.image) {
            const img = document.createElement('img');
            img.src = product.image;
            img.alt = product.alt;
            img.width = 700;
            img.height = 700;
            img.loading = 'lazy';
            media.append(img);
          }
          link.setAttribute('aria-label', product.title);
          const heading = document.createElement('div');
          heading.className = 'salex-card-heading-wrap';
          if (product.headingHtml) heading.innerHTML = product.headingHtml;
          else {
            const title = document.createElement('h3');
            title.className = 'salex-card-model';
            title.textContent = product.title;
            heading.append(title);
          }
          const priceArea = document.createElement('div');
          priceArea.className = 'salex-card-price-area';
          const price = document.createElement('strong');
          price.className = 'salex-card-price';
          if (product.priceHtml) price.innerHTML = product.priceHtml;
          else price.textContent = product.priceLabel;
          priceArea.append(price);
          if (this.dataset.taxNote) {
            const tax = document.createElement('span');
            tax.className = 'salex-card-tax';
            tax.textContent = this.dataset.taxNote;
            priceArea.append(tax);
          }
          const more = document.createElement('span');
          more.className = 'salex-result-card__link salex-card-cta';
          more.setAttribute('aria-hidden', 'true');
          more.append(document.createTextNode(this.dataset.view));
          const arrow = document.createElement('span');
          arrow.className = 'salex-card-cta__arrow';
          arrow.textContent = '→';
          more.append(arrow);
          link.append(media, heading, priceArea, more);
          li.append(link);
          fragment.append(li);
        }
        grid.append(fragment);
        const content = document.createElement('div');
        content.className = 'salex-results-content';
        if (products.length) content.append(grid);
        else {
          const empty = document.createElement('p');
          empty.className = 'salex-results-message';
          const mascot = this.querySelector('template[data-salli-empty]')?.content.cloneNode(true);
          if (mascot) empty.append(mascot);
          empty.append(document.createTextNode(this.dataset.empty));
          content.append(empty);
        }
        if (pages > 1) {
          const navigation = document.createElement('nav');
          navigation.className = 'salex-result-pages';
          const previous = document.createElement('button');
          const next = document.createElement('button');
          const current = document.createElement('span');
          previous.type = next.type = 'button';
          previous.textContent = '← ' + this.dataset.previous;
          next.textContent = this.dataset.next + ' →';
          previous.disabled = page === 1;
          next.disabled = page === pages;
          current.textContent = `${page} / ${pages}`;
          const changePage = nextPage => {
            const url = new URL(window.location.href);
            url.searchParams.set('sx_page', String(nextPage));
            history.pushState(null, '', url);
            this.render(products, target, nextPage);
            target.scrollIntoView({behavior:'smooth', block:'start'});
          };
          previous.addEventListener('click', () => changePage(page - 1));
          next.addEventListener('click', () => changePage(page + 1));
          navigation.append(previous, current, next);
          content.append(navigation);
        }
        target.replaceChildren(content);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["salex-spec-filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('salex-spec-filters')) {
    const optionRequests = new Map();
    customElements.define('salex-spec-filters', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const active = new URL(window.location.href).searchParams.getAll('sx');
        if (active.length) {
          this.querySelectorAll('[data-salex-tag]').forEach(input => {
            input.checked = active.includes(input.value);
            if (input.checked) input.closest('details').open = true;
          });
        }
        this.sortOptions();
        this.refreshSelection();
        this.addEventListener('change', event => {
          const input = event.target;
          if (!(input instanceof HTMLInputElement) || !input.matches('[data-salex-tag]')) return;
          event.stopPropagation();
          this.refreshSelection();
        }, {signal});
        this.addEventListener('click', event => {
          if (!event.target.closest('[data-salex-clear-specs]')) return;
          this.querySelectorAll('[data-salex-tag]').forEach(input => { input.checked = false; });
          this.refreshSelection();
        }, {signal});
        this.addEventListener('input', event => {
          if (!(event.target instanceof HTMLInputElement)) return;
          if (event.target.type !== 'search') return;
          event.stopPropagation();
          const needle = event.target.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
          event.target.closest('details')?.querySelectorAll('.salex-filter-options li').forEach(option => {
            const value = option.textContent.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
            option.hidden = !value.includes(needle);
          });
        }, {signal});
        this.addEventListener('keydown', event => {
          if (event.target instanceof HTMLInputElement && event.key === 'Enter') event.preventDefault();
        }, {signal});
        this.loadFullOptions();
      }
      sortOptions() {
        const collator = new Intl.Collator(document.documentElement.lang || 'sk', {numeric:true, sensitivity:'base'});
        this.querySelectorAll('.salex-filter-options').forEach(list => {
          list.append(...[...list.children].sort((a, b) => collator.compare(a.textContent.trim(), b.textContent.trim())));
        });
      }
      async loadFullOptions() {
        const current = new URL(window.location.href);
        const source = new URL(this.dataset.collectionUrl, window.location.origin);
        const nativeFilters = [...current.searchParams.keys()].some(key => key.startsWith('filter.'));
        if (!nativeFilters && current.pathname.replace(/\/$/, '') === source.pathname.replace(/\/$/, '')) return;
        source.searchParams.set('view', 'salex-filter-options');
        if (current.searchParams.has('preview_theme_id')) source.searchParams.set('preview_theme_id', current.searchParams.get('preview_theme_id'));
        const key = source.toString();
        try {
          if (!optionRequests.has(key)) optionRequests.set(key, fetch(source).then(response => {
            if (!response.ok) throw new Error('Options request failed');
            return response.text();
          }));
          const html = await optionRequests.get(key);
          if (!this.isConnected) return;
          const options = new DOMParser().parseFromString(html, 'text/html').querySelector('salex-spec-filters');
          if (!options) throw new Error('Invalid options response');
          const inputs = [...this.querySelectorAll('[data-salex-tag]')];
          const applied = [...current.searchParams.getAll('sx'), ...[...this.querySelectorAll('[data-salex-applied-tag]')].map(input => input.value)];
          const checked = [...inputs.filter(input => input.checked).map(input => input.value), ...applied.filter(value => !inputs.some(input => input.value === value))];
          const opened = [...this.querySelectorAll('details[open]')].map(group => group.dataset.specGroup);
          const preserved = [...this.querySelectorAll('[data-salex-preserved-tag]')];
          this.replaceChildren(...options.childNodes);
          this.prepend(...preserved);
          this.querySelectorAll('[data-salex-tag]').forEach(input => { input.checked = checked.includes(input.value); });
          this.querySelectorAll('details').forEach(group => { group.open = opened.includes(group.dataset.specGroup) || !!group.querySelector(':checked'); });
          this.sortOptions();
          this.refreshSelection();
        } catch {
          optionRequests.delete(key);
        }
      }
      refreshSelection() {
        this.querySelectorAll('[data-salex-tag]').forEach(input => {
          input.closest('label').classList.toggle('is-selected', input.checked);
        });
        this.querySelectorAll('details').forEach(group => {
          const selected = [...group.querySelectorAll('[data-salex-tag]:checked')];
          let summary = group.querySelector('summary > span small');
          if (!summary && selected.length) {
            summary = document.createElement('small');
            group.querySelector('summary > span').append(summary);
          }
          if (summary) summary.textContent = selected.map(input => input.nextElementSibling.textContent).join(', ');
        });
        const count = this.querySelector('.salex-filter-selection strong span');
        const total = this.querySelectorAll('[data-salex-tag]:checked').length;
        if (count) count.textContent = total;
        const selection = this.querySelector('.salex-filter-selection');
        if (selection) selection.hidden = total === 0;
        const form = this.closest('facets-form-component');
        const badge = form?.querySelector('[data-pending-count]');
        if (badge) { badge.textContent = total; badge.hidden = total === 0; }
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
